<template>
  <router-view />
</template>

<script setup>
// 引入全局样式
import './assets/css/global.css'
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
